import React from "react";
import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { MEDIA } from "@/lib/media";
import { Paw } from "@/components/decor";

export default function NotFound() {
  useSeo("Page Not Found", "This page went walkies.");
  return (
    <div className="relative min-h-[70vh] flex items-center justify-center px-4 overflow-hidden text-center">
      <div className="absolute inset-0 opacity-[0.05]">{[...Array(8)].map((_, i) => <Paw key={i} className="absolute w-24 h-24 text-[#19324A]" style={{ top: `${(i * 31) % 90}%`, left: `${(i * 43) % 90}%`, transform: `rotate(${i * 40}deg)` }} />)}</div>
      <div className="relative">
        <img src={MEDIA.chewie} alt="Chewie looking guilty" className="w-40 h-40 object-cover rounded-full mx-auto ring-4 ring-white soft-shadow" />
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl text-[#19324A] mt-6">UH-OH…</h1>
        <p className="font-display font-bold text-xl text-[#FF6B9D] mt-2">CHEWIE & SOLO MAY HAVE EATEN THIS PAGE.</p>
        <p className="text-[#19324A]/65 mt-4 max-w-md mx-auto">We looked under the couch. We checked the biscuit cupboard. It's definitely gone.</p>
        <Link to="/" className="btn-primary mt-7 inline-flex" data-testid="notfound-home-btn">TAKE ME HOME</Link>
      </div>
    </div>
  );
}
